import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'UniformAuthService',
    controller: 'RoleInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'GetItemPagingList',
    'GetAllItems',
    'SetRoleAuth',
    'GetRoleTiers',
    'IsAdministrator'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const RoleApi = ZJApi.defineNewApi('RoleApi', factory)

export default RoleApi